import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import './QualityStandardsSection.css';

const features = [
  {
    title: 'Quality driven product',
    description: 'Our QA experts are highly experienced and always aim not to leave the project with a single bug. Our team check for bugs in the general codebase as well as the business logic.'
  },
  {
    title: 'Highly-Efficient',
    description: 'Our team is expert in exploring the latest technologies which makes an app run smoother and faster. Our team uses the best practise for code and provide comments on every piece of code.'
  },
  {
    title: 'Highly-Secure',
    description: 'We use the various types of protocols and encryptions to make the app developed more secure. Security of the app is our major concern.'
  },
  {
    title: 'Maintainable',
    description: "We invest time and knowledge in designing of the app's architecture so as to achieve maintainability and scalability. We are strong believers of multi-tiered architecture which allows us to improve different parts of code as required."
  }
];

const QualityStandardsSection = () => {
  return (
    <Box className="quality-standards-section">
      <Container maxWidth="lg">
        <motion.div
          className="quality-content"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h2"
            className="quality-title"
            component={motion.h2}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Commitment to Excellence
          </Typography>
          <Typography
            className="quality-subtitle"
            component={motion.p}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            We are more prone to writing clean code as well as scalability and maintainability of the product. Our tech experts are always ready to suggest you the best feasible technological solutions.
          </Typography>

          <div className="features-grid">
            {features.map((feature, index) => (
              <motion.div
                key={feature.title}
                className="feature-text"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 + index * 0.1 }}
              >
                <Typography variant="h3" className="feature-title">
                  {feature.title}
                </Typography>
                <Typography className="feature-description">
                  {feature.description}
                </Typography>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </Container>
    </Box>
  );
};

export default QualityStandardsSection; 